import { Catalog } from '../../../../apis/search-catalog';

export type CatalogIdentifierStrategy = (catalog: Catalog) => string | number;

export const getCatalogIdentifier: CatalogIdentifierStrategy = (catalog) =>
  catalog.slug;
